const itemDb = document.getElementById('spo_qjctgy').innerHTML;
const elementCache = {};
const isPhoneScreenSize = window.screen.width < 640;

let forOwn = function (obj, func) {
  let keys = Object.getOwnPropertyNames(obj);
  keys.forEach(function (key) {
    func.call(obj, obj[key], key, obj);
  });
};

let visibleItems = [];
let selectedItemIndex = 0;
let lastQuery;

const list = document.querySelector(".c-category-quick-jump");

if (list) {
  const elements = list.querySelectorAll("li");
  for (const element of elements) {
    const id = element.dataset.categoryId;
    elementCache[id] = element;
  }
}

const quickJumpInput = document.getElementById("qjctgy-filter");

if (!isPhoneScreenSize) {
  quickJumpInput.focus();
} else {
  quickJumpInput.addEventListener("touchend", (e) => {
    if (!isPhoneScreenSize) {
      return;
    }
    let quickJumpPosition = quickJumpInput.getBoundingClientRect();

    quickJumpInput.focus();

    if (quickJumpPosition.top > 15) {
      e.preventDefault();
    }
    window.scrollTo(0, getAbsoluteOffsetTop(quickJumpInput) - 10);
  });
}

if (quickJumpInput) {
  quickJumpInput.addEventListener("keyup", () => {
    const searchTerm = quickJumpInput.value
      .replace(/[^a-zA-Z0-9\\.\\w]/gi, "")
      .replace(/\./, "\\.");
    if (lastQuery == searchTerm) return;

    lastQuery = searchTerm;
    if (searchTerm.length === 0) {
      forOwn(elementCache, (i) => {
        i.style.display = "block";
        i.classList.remove("is-selected");
      });

      selectedItemIndex = 0;
      visibleItems = [];
      return;
    }

    var search = new RegExp("\\|[^|]*?" + searchTerm + "[^|]*?\\$(\\d\\w+)", "gi");
    var match = [];

    forOwn(elementCache, (i) => {
      i.style.display = "none";
      i.classList.remove("is-selected");
    });

    visibleItems = [];
    while ((match = search.exec(itemDb)) !== null) {
      const [, categoryId] = match;
      const element = elementCache[categoryId];
      if (!element) {
        console.warn(`Category not found: ${categoryId}`);
        continue;
      }

      visibleItems.push(element);
      element.style.display = "block";
    }

    selectedItemIndex = 0;
    if (visibleItems.length) {
      visibleItems[selectedItemIndex].classList.add("is-selected");
    }
  });

  quickJumpInput.addEventListener("keydown", (e) => {
    if (!visibleItems.length) return;

    let handled = false;
    let newSelectedItemIndex = selectedItemIndex;
    const itemsPerRow = Math.ceil(
      list.clientWidth / visibleItems[0].clientWidth
    );

    if (e.keyCode == 37) {
      // left
      const isAtStart =
        e.target.selectionStart == e.target.selectionEnd &&
        e.target.selectionStart == 0;
      if ((e.ctrlKey || isAtStart) && newSelectedItemIndex >= 1) {
        handled = true;
        newSelectedItemIndex = newSelectedItemIndex - 1;
      }
    } else if (e.keyCode == 38) {
      // up
      handled = true;
      if (newSelectedItemIndex - itemsPerRow >= 0)
        newSelectedItemIndex = newSelectedItemIndex - itemsPerRow;
    } else if (e.keyCode == 39) {
      // right
      const isAtEnd =
        e.target.selectionStart == e.target.selectionEnd &&
        e.target.selectionStart == e.target.value.length;
      if (
        (e.ctrlKey || isAtEnd) &&
        newSelectedItemIndex < visibleItems.length - 1
      ) {
        handled = true;
        newSelectedItemIndex = newSelectedItemIndex + 1;
      }
    } else if (e.keyCode == 40) {
      // down
      handled = true;
      if (newSelectedItemIndex + itemsPerRow <= visibleItems.length - 1)
        newSelectedItemIndex = newSelectedItemIndex + itemsPerRow;
    } else if (e.keyCode == 13) {
      // enter
      const visibleItem = visibleItems[selectedItemIndex];
      if (visibleItem) {
        const newHref = visibleItem.querySelector("a").getAttribute("href");
        window.location.href = newHref;
        handled = true;
      }
    }

    if (handled) {
      e.preventDefault();
      e.stopPropagation();

      if (newSelectedItemIndex != selectedItemIndex) {
        visibleItems[selectedItemIndex].classList.remove("is-selected");
        visibleItems[newSelectedItemIndex].classList.add("is-selected");
        selectedItemIndex = newSelectedItemIndex;
      }
    }
  });
}

// blugh 43243432432
